/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AgentVariantsResponse } from '../models/AgentVariantsResponse';
import type { AgentVariantsUpdate } from '../models/AgentVariantsUpdate';
import type { CampaignCopyRequest } from '../models/CampaignCopyRequest';
import type { CampaignCreate } from '../models/CampaignCreate';
import type { CampaignExportBundle_Output } from '../models/CampaignExportBundle_Output';
import type { CampaignImportRequest } from '../models/CampaignImportRequest';
import type { CampaignImportResult } from '../models/CampaignImportResult';
import type { CampaignResponse } from '../models/CampaignResponse';
import type { CampaignTransferRequest } from '../models/CampaignTransferRequest';
import type { CampaignUpdate } from '../models/CampaignUpdate';
import type { PaginatedCampaignsResponse } from '../models/PaginatedCampaignsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminCampaignsService {
    /**
     * Get Campaigns
     * @param status
     * @param limit
     * @param offset
     * @returns PaginatedCampaignsResponse Successful Response
     * @throws ApiError
     */
    public static getCampaignsApiAdminCampaignsGet(
        status?: (string | null),
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<PaginatedCampaignsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/campaigns',
            query: {
                'status': status,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Campaign
     * @param requestBody
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static createCampaignApiAdminCampaignsPost(
        requestBody: CampaignCreate,
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/campaigns',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Campaign
     * Get a single campaign by id, including the selected org-credential
     * name (``llm_credential_key_name``).
     * @param campaignId
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static getCampaignApiAdminCampaignsCampaignIdGet(
        campaignId: string,
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/campaigns/{campaign_id}',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Campaign
     * @param campaignId
     * @param requestBody
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static updateCampaignApiAdminCampaignsCampaignIdPatch(
        campaignId: string,
        requestBody: CampaignUpdate,
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/admin/campaigns/{campaign_id}',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Campaign
     * @param campaignId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteCampaignApiAdminCampaignsCampaignIdDelete(
        campaignId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/campaigns/{campaign_id}',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Copy Campaign
     * @param campaignId
     * @param requestBody
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static copyCampaignApiAdminCampaignsCampaignIdCopyPost(
        campaignId: string,
        requestBody?: (CampaignCopyRequest | null),
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/campaigns/{campaign_id}/copy',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Transfer Campaign
     * @param campaignId
     * @param requestBody
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static transferCampaignApiAdminCampaignsCampaignIdTransferPost(
        campaignId: string,
        requestBody: CampaignTransferRequest,
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/campaigns/{campaign_id}/transfer',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Campaign
     * Export a campaign settings, prompts and secret-key placeholders as JSON
     * @param campaignId
     * @returns CampaignExportBundle_Output Successful Response
     * @throws ApiError
     */
    public static exportCampaignApiAdminCampaignsCampaignIdExportGet(
        campaignId: string,
    ): CancelablePromise<CampaignExportBundle_Output> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/campaigns/{campaign_id}/export',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Import Campaign
     * Import a bundle produced by :func:`export_campaign` into the caller's
     * organization. By default a new campaign is created; pass
     * ``target_campaign_id`` to overwrite an existing campaign in place
     * (preserving its id, name and status). The bundle's ``schema_version`` must
     * match the server's supported version.
     * @param requestBody
     * @returns CampaignImportResult Successful Response
     * @throws ApiError
     */
    public static importCampaignApiAdminCampaignsImportPost(
        requestBody: CampaignImportRequest,
    ): CancelablePromise<CampaignImportResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/campaigns/import',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Agent Variants
     * The campaign's caller-agent A/B variants (up to 5 active).
     *
     * A campaign with no variants splits nothing and dials with its
     * ``default_agent_id``; the response ``variants`` list is then empty.
     * @param campaignId
     * @returns AgentVariantsResponse Successful Response
     * @throws ApiError
     */
    public static getAgentVariantsApiAdminCampaignsCampaignIdAgentVariantsGet(
        campaignId: string,
    ): CancelablePromise<AgentVariantsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/campaigns/{campaign_id}/agent-variants',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Replace Agent Variants
     * Replace the campaign's caller-agent variant set (replace-managed).
     *
     * Accepts up to 5 active variants ``{agent_id, label, weight, active}``
     * (validated: ≤5 active, weights ≥ 0, non-empty agent_ids/labels). An empty
     * list clears the split so the campaign falls back to ``default_agent_id``.
     * @param campaignId
     * @param requestBody
     * @returns AgentVariantsResponse Successful Response
     * @throws ApiError
     */
    public static replaceAgentVariantsApiAdminCampaignsCampaignIdAgentVariantsPut(
        campaignId: string,
        requestBody: AgentVariantsUpdate,
    ): CancelablePromise<AgentVariantsResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/campaigns/{campaign_id}/agent-variants',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Start Campaign Admin
     * Kick off a campaign for a contact (admin endpoint).
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static startCampaignAdminApiAdminCampaignsStartPost(
        requestBody: Record<string, any>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/campaigns/start',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Campaigns
     * @param status
     * @param limit
     * @param offset
     * @returns PaginatedCampaignsResponse Successful Response
     * @throws ApiError
     */
    public static getCampaignsAdminCampaignsGet(
        status?: (string | null),
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<PaginatedCampaignsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/campaigns',
            query: {
                'status': status,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Campaign
     * @param requestBody
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static createCampaignAdminCampaignsPost(
        requestBody: CampaignCreate,
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/campaigns',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Campaign
     * Get a single campaign by id, including the selected org-credential
     * name (``llm_credential_key_name``).
     * @param campaignId
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static getCampaignAdminCampaignsCampaignIdGet(
        campaignId: string,
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/campaigns/{campaign_id}',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Campaign
     * @param campaignId
     * @param requestBody
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static updateCampaignAdminCampaignsCampaignIdPatch(
        campaignId: string,
        requestBody: CampaignUpdate,
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/admin/campaigns/{campaign_id}',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Campaign
     * @param campaignId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteCampaignAdminCampaignsCampaignIdDelete(
        campaignId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/campaigns/{campaign_id}',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Copy Campaign
     * @param campaignId
     * @param requestBody
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static copyCampaignAdminCampaignsCampaignIdCopyPost(
        campaignId: string,
        requestBody?: (CampaignCopyRequest | null),
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/campaigns/{campaign_id}/copy',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Transfer Campaign
     * @param campaignId
     * @param requestBody
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static transferCampaignAdminCampaignsCampaignIdTransferPost(
        campaignId: string,
        requestBody: CampaignTransferRequest,
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/campaigns/{campaign_id}/transfer',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Campaign
     * Export a campaign settings, prompts and secret-key placeholders as JSON
     * @param campaignId
     * @returns CampaignExportBundle_Output Successful Response
     * @throws ApiError
     */
    public static exportCampaignAdminCampaignsCampaignIdExportGet(
        campaignId: string,
    ): CancelablePromise<CampaignExportBundle_Output> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/campaigns/{campaign_id}/export',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Import Campaign
     * Import a bundle produced by :func:`export_campaign` into the caller's
     * organization. By default a new campaign is created; pass
     * ``target_campaign_id`` to overwrite an existing campaign in place
     * (preserving its id, name and status). The bundle's ``schema_version`` must
     * match the server's supported version.
     * @param requestBody
     * @returns CampaignImportResult Successful Response
     * @throws ApiError
     */
    public static importCampaignAdminCampaignsImportPost(
        requestBody: CampaignImportRequest,
    ): CancelablePromise<CampaignImportResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/campaigns/import',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Agent Variants
     * The campaign's caller-agent A/B variants (up to 5 active).
     *
     * A campaign with no variants splits nothing and dials with its
     * ``default_agent_id``; the response ``variants`` list is then empty.
     * @param campaignId
     * @returns AgentVariantsResponse Successful Response
     * @throws ApiError
     */
    public static getAgentVariantsAdminCampaignsCampaignIdAgentVariantsGet(
        campaignId: string,
    ): CancelablePromise<AgentVariantsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/campaigns/{campaign_id}/agent-variants',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Replace Agent Variants
     * Replace the campaign's caller-agent variant set (replace-managed).
     *
     * Accepts up to 5 active variants ``{agent_id, label, weight, active}``
     * (validated: ≤5 active, weights ≥ 0, non-empty agent_ids/labels). An empty
     * list clears the split so the campaign falls back to ``default_agent_id``.
     * @param campaignId
     * @param requestBody
     * @returns AgentVariantsResponse Successful Response
     * @throws ApiError
     */
    public static replaceAgentVariantsAdminCampaignsCampaignIdAgentVariantsPut(
        campaignId: string,
        requestBody: AgentVariantsUpdate,
    ): CancelablePromise<AgentVariantsResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/campaigns/{campaign_id}/agent-variants',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Start Campaign Admin
     * Kick off a campaign for a contact (admin endpoint).
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static startCampaignAdminAdminCampaignsStartPost(
        requestBody: Record<string, any>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/campaigns/start',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
